import React, { useContext, useEffect, useRef } from 'react';

import config from '../../config';
import { stringsStartsWithIgnoreCase } from '../../util';
import ApplicationContext from '../../ApplicationContext';

export enum DashboardEvent {
  Bill,
  Invoice,
  Crdb,
  GeneralInvoice,
  GeneralBill,
  CustomerPayment,
  BillPayment,
  CreditCardPayment,
  DepositCheckClear,
  UndoDepositCancelCheckClear,
  DailyActRpt,
  BankBalance,
  BankRecon,
  TrialBalanceRpt,
  AgentStatement,
  CustomerStatement,
  AgentBalanceRpt,
  CustomerBalanceRpt,
  VendorBalanceRpt,
  EstProfitRpt,
  GProfitRpt,
  BusinessIntelligence,
  OrchidBaro,
};

interface DashboardProps {
  onClick: (e:DashboardEvent) => void,
};

function Dashboard({ onClick }: DashboardProps) {

  const containerRef = useRef<HTMLDivElement>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    initializeEventListeners();

    return uninitializeEventListeners;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function initializeEventListeners() {
    window.addEventListener('message', onMessage);
  }

  function uninitializeEventListeners() {
    window.removeEventListener('message', onMessage);
  }

  function onMessage(e:MessageEvent) {
    if (typeof e.data === 'string') {
      const messageString = e.data as string;

      if (stringsStartsWithIgnoreCase(messageString, 'OPIL')) {
        onClick(DashboardEvent.Invoice);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'OPBL')) {
        onClick(DashboardEvent.Bill);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'OPCL')) {
        onClick(DashboardEvent.Crdb);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'GARL')){
        onClick(DashboardEvent.GeneralInvoice);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'GAPL')){
        onClick(DashboardEvent.GeneralBill);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'CUPY')){
        onClick(DashboardEvent.CustomerPayment);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'BIPY')){
        onClick(DashboardEvent.BillPayment);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'CCPY')){
        onClick(DashboardEvent.CreditCardPayment);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'DECC')){
        onClick(DashboardEvent.DepositCheckClear);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'UDCC')){
        onClick(DashboardEvent.UndoDepositCancelCheckClear);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'DAAR')){
        onClick(DashboardEvent.DailyActRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'DABB')){
        onClick(DashboardEvent.BankBalance);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'DABR')){
        onClick(DashboardEvent.BankRecon);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'TRBR')){
        onClick(DashboardEvent.TrialBalanceRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'AGTS')){
        onClick(DashboardEvent.AgentStatement);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'CUTS')){
        onClick(DashboardEvent.CustomerStatement);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'AGBR')){
        onClick(DashboardEvent.AgentBalanceRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'CUBR')){
        onClick(DashboardEvent.CustomerBalanceRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'VEBR')){
        onClick(DashboardEvent.VendorBalanceRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'ESPR')){
        onClick(DashboardEvent.EstProfitRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'GSPR')){
        onClick(DashboardEvent.GProfitRpt);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'BNIG')){
        onClick(DashboardEvent.BusinessIntelligence);
      }
      if (stringsStartsWithIgnoreCase(messageString, 'OCBO')){
        onClick(DashboardEvent.OrchidBaro);
      }
    }
  }

  const containerStyle:React.CSSProperties = {
    border: 'none',
    width: 'calc(100% - 210px)',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
  };

  const frameStyle:React.CSSProperties = {
    border: 'none',
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
  };

  //let dashboardUrl = config.dashboardUrl;

  // switch (selectedOperation) {
  //   case 'Ocean Import':
  //     dashboardUrl = 'http://dash2.suntekscm.com/home_OI.html';
  //     break;
  //   case 'Ocean Export':
  //     dashboardUrl = 'http://dash2.suntekscm.com/home_OE.html';
  //     break;
  //   case 'Air Import':
  //     dashboardUrl = 'http://dash2.suntekscm.com/home_AI.html';
  //     break;
  //   case 'Air Export':
  //     dashboardUrl = 'http://dash2.suntekscm.com/home_AE.html';
  //     break;
  //   case 'Warehousing':
  //     dashboardUrl = 'http://dash2.suntekscm.com/home_WH.html';
  //     break;
  //   case 'Accounting':
  //     dashboardUrl = 'http://dash2.suntekscm.com/home_ACCT.html';
  //     break;
  //   default:
  //     break;
  // }

  const appContext = useContext(ApplicationContext);
  const dashboardId = !appContext.useDarkMode ? 'dashboard-container' : 'dashboard-container-dark';
  const dashboardUrl = !appContext.useDarkMode ? config.dashboardUrl : config.dashboardUrlDark;

  return (
    <div id={dashboardId} ref={containerRef} style={containerStyle}>
      <iframe id="dashboard-frame" ref={iframeRef} style={frameStyle} title="Dashboard" src={dashboardUrl} />
    </div>
  );
}

export default Dashboard;
